// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cabb60ab","820":"3f06ecd9","827":"a1d67b2c"}[chunkId] + ".chunk.js";
};